import React from 'react';

import Udlap from './sections/Udlap'
import Coding from './sections/Coding'
import Nasa from './sections/Nasa'
import Disney from './sections/Disney'
import Amazon from './sections/Amazon'
import '../styles/drawer.css'
import '../styles/actions.css'
import SvgClose from '../images/svg/SvgClose'

import posed from 'react-pose';
import { easing } from 'popmotion';

const Close = posed.div({
    pressable: true,
    init: {scale: 1, rotate: 0},
    press: {scale: 0.8, rotate: 360},
    hoverable: true,
    hover: {
        scale: 1.2,
        boxShadow: '0px 5px 10px rgba(0,0,0,0.2)'
    }
});

const DrawerContainer = posed.div({
    hidden: {
        x: '-120%',
        transition: {
            duration: 1000,
            ease: easing.easeIn
        }
    },
    visible: {
        x: '0',
        transition: {
            duration: 500,
            ease: easing.easeInOut
        }
    }
})

const sections = (section) => {
    switch (section) {
        case 'udlap':
            return <Udlap></Udlap>;
        case 'coding':
            return <Coding></Coding>
        case 'nasa':
            return <Nasa></Nasa>
        case 'disney':
            return <Disney></Disney>
        case 'amazon':
            return <Amazon></Amazon>
        default:
            return <Udlap/>;
    }
}

const Drawer = ({ open, content, onClick }) => {


    // if(open) {
    return (
        <DrawerContainer className="container" pose={open ? 'visible' : 'hidden'}>
            <div className="drawer">
                <Close className="xCloseButton">
                    <SvgClose onClick={onClick}></SvgClose>
                </Close>
                <div>
                    { sections(content) }
                </div>
            </div>
        </DrawerContainer>
    );
    // } else {
    //     return(<div></div>);
    // }
}



export default Drawer;


// WEBPACK FOOTER //
// ./src/components/Drawer.jsx